"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personBySlug = exports.colleaguesOf = void 0;
/**
 * Query builder for the person pages
 *
 * @param {object} options
 * @param {string} options.slug - The slug for the person
 * @returns {object} Contentful query
 */
var personBySlug = function personBySlug(_ref) {
  var slug = _ref.slug;
  return {
    content_type: 'person',
    'fields.slug': slug,
    'fields.external': false
  };
};

/**
 * Query builder for the colleages of a person
 *
 * @param {object} options
 * @param {string} options.slug - The slug of the person to exclude
 * @returns {object} Contentful query
 */
exports.personBySlug = personBySlug;
var colleaguesOf = function colleaguesOf(_ref2) {
  var slug = _ref2.slug;
  return {
    content_type: 'person',
    select: 'sys.contentType,fields.name,fields.jobTitle,fields.slug,fields.image,fields.external',
    'fields.slug[ne]': slug,
    'fields.external': false
  };
};
exports.colleaguesOf = colleaguesOf;